/**
 * Body property: the width a settings pane covers at the active view's inline
 * end; unset without one. The view's floating bottom row (the context dock
 * with the AI island) keeps clear of it, so the pane's own controls stay
 * reachable.
 */
export const VIEW_PANE_INLINE_END_PROPERTY =
  '--streamlain-view-pane-inline-end';
